import { useEffect } from 'react';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LaundryOrDryCleaning',
  name: 'Lavandería Colón',
  description:
    'Lavandería profesional en Barcelona con servicio de recogida y entrega a domicilio para particulares, hoteles, restaurantes, spas y centros médicos.',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/4d2bea2dc98a7e73f49e9d87ac7b145a/545924125de435e3ed3a074a7a9f96d5.png',
  image:
    'https://static.readdy.ai/image/4d2bea2dc98a7e73f49e9d87ac7b145a/545924125de435e3ed3a074a7a9f96d5.png',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Calle Ample 9',
    addressLocality: 'Barcelona',
    postalCode: '08002',
    addressRegion: 'Cataluña',
    addressCountry: 'ES',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 41.3828,
    longitude: 2.1827,
  },
  telephone: ['+34620550559', '+34933020486'],
  email: 'lavanderiaacolon@gmail.com',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '20:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Saturday'],
      opens: '09:00',
      closes: '14:00',
    },
  ],
  priceRange: '€€',
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  hasMap: 'https://maps.google.com/?q=Calle+Ample+9,+Barcelona',
  sameAs: ['https://wa.me/34620550559'],
  serviceType: [
    'Lavandería a domicilio',
    'Lavandería para hoteles',
    'Lavandería para restaurantes',
    'Lavandería para spas',
    'Lavandería para centros médicos',
    'Recogida y entrega de ropa',
  ],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '¿Hacéis recogida y entrega a domicilio en Barcelona?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí, ofrecemos servicio de recogida y entrega gratuito en toda Barcelona y alrededores. Coordinamos el horario directamente contigo para tu máxima comodidad.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Cuánto tarda el servicio de lavandería?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Nuestro servicio estándar tiene un plazo de entrega de 24 horas. Para pedidos urgentes, consúltanos directamente llamando al 620 550 559.',
      },
    },
    {
      '@type': 'Question',
      name: '¿Dónde está ubicada Lavandería Colón?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Estamos en Calle Ample 9, 08002 Barcelona, en el Barrio Gótico. Puedes visitarnos o contactarnos por teléfono (620 550 559 / 933 020 486) o email (lavanderiaacolon@gmail.com).',
      },
    },
    {
      '@type': 'Question',
      name: '¿Ofrecéis servicio para hoteles y restaurantes?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí, ofrecemos servicio especializado para hoteles, restaurantes, apartamentos turísticos, spas y centros médicos. Garantizamos entregas puntuales y calidad premium en cada prenda.',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Lavandería Colón Barcelona | Calle Ample 9 - Servicio Profesional de Lavandería',
  description:
    'Lavandería profesional en Barcelona con recogida y entrega a domicilio. Servicios para particulares, hoteles, restaurantes, spas y centros médicos.',
  url: siteUrl,
  inLanguage: 'es-ES',
  isPartOf: {
    '@type': 'WebSite',
    name: 'Lavandería Colón',
    url: siteUrl,
  },
  about: {
    '@type': 'LaundryOrDryCleaning',
    name: 'Lavandería Colón',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Inicio',
        item: siteUrl,
      },
    ],
  },
};

export default function SeoJsonLd() {
  useEffect(() => {
    const schemas = [localBusinessSchema, faqSchema, webPageSchema];
    const scriptIds = ['schema-local-business', 'schema-faq', 'schema-webpage'];

    schemas.forEach((schema, i) => {
      let script = document.getElementById(scriptIds[i]) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = scriptIds[i];
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      scriptIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return null;
}
